import { Klass } from "@pressmedia/webappbase";
import pluginConfig from "./quill.config";
import addHr  from "./quill-hr";

export default {
	theme: "snow",
	Quill: null,
	
	// プラグインの設定
	pluginConfig,
	
	async _importPlugin(wndw) {
		!wndw && (wndw = window);
		
		if(!wndw.Quill) {
			const uri = `${this.pluginConfig.CDNroot}/${this.pluginConfig.version}/quill.min.js`;
			await new Promise( (resolve, reject) => this.app.require(uri, {
				doc: wndw.document,
				success: resolve,
				error: reject
			}) );
			
			if(wndw === window) {
				Klass("VuwWysiwygField").prototype.Quill = wndw.Quill;
			}
		}
		
		if(!wndw.Quill.__customizedByVuwWysiwygField) {
			addHr(wndw.Quill);
			
			const icons = wndw.Quill.import("ui/icons");
			!!icons && Object.assign(icons, this.pluginConfig.toolbar.icons);
			wndw.Quill.__customizedByVuwWysiwygField = true;
		}
		
		return true;
	},
	
	async _importPluginStyleSheet(wndw) {
		!wndw && (wndw = window);
		
		const fname = `quill.${this.theme}.css`;
		
		// [is imported?]
		const reg = new RegExp(`${RegExp.escape(fname)}$`);
		const len = wndw.document.styleSheets.length;
		for(let i = 0; i < len; i++) {
			const style = wndw.document.styleSheets.item(i);
			if( style.href && reg.test(style.href) ) {
				// 読み込み済みの場合は終了
				return true;
			}
		}
		
		const uri = `${this.pluginConfig.CDNroot}/${this.pluginConfig.version}/${fname}`;
		await new Promise( (resolve, reject) => this.app.require(uri, {
			doc: wndw.document,
			type: "stylesheet",
			success: resolve,
			error: reject
		}) );
		
		return true;
	}
}
